const NUMBERS_ONLY_ERROR = 'Enter numbers only.';
const LETTERS_ONLY_ERROR = 'Enter letters only.';

const digitsOnlyError = (value: string): string | null =>
  value === '' || /^[0-9]+$/.test(value) ? null : NUMBERS_ONLY_ERROR;

const decimalNumberError = (value: string): string | null =>
  value === '' || /^(?:\d+\.?\d*|\.\d+)$/.test(value) ? null : NUMBERS_ONLY_ERROR;

const letterGradeError = (value: string): string | null =>
  value === '' || /^[A-Za-z]+$/.test(value) ? null : LETTERS_ONLY_ERROR;

export { decimalNumberError, digitsOnlyError, letterGradeError };
